import React, { useState, useEffect, forwardRef } from 'react';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder, faSearch } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger, Tooltip, Dropdown, Modal, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getDisplayedName, getOutputExtensions } from '../../dataProvider/file.js'
import { getIcon } from '../../dataProvider/uploadIcons.js'
import { updateFile, removeFile, UPLOAD_STATUS_ERROR_MAX_SIZE, getMaxUploadSize } from '../../actions/file.js'
import useWindowDimensions from "../util/Window.js"

import { UploadValidation, UploadDropdown } from '../util/Svg.jsx'
import LoadingArrowIcon from "../../img/v1/upload/loading-arrows.svg"
import trashIcon from "../../img/v2/home/upload/trash.png";

import LoadingIconV2 from "../../img/v2/upload/loading.png"

function UploadFileTableElement(props) {

    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const [progress, setProgress] = useState(200);
    const [mobileSelect, setMobileSelect] = useState(false);
    const [file, setFile] = useState(null);
    const [search, setSearch] = useState("");

    useEffect(() => {

        setFile(props.displayedFile);
        if (props.compress && progress === 200 && Date.now() - props.displayedFile.id <= 1000) setProgress(0)
        if (props.split && progress === 200 && Date.now() - props.displayedFile.id <= 1000) setProgress(0)

        const interval = setInterval(() => {
            let adjustedStep = 5;
            if (progress === 45 || progress === 55 || progress === 75 || progress === 90) {
                adjustedStep = 1;
            } else if (progress % 5 !== 0) {
                adjustedStep = 1;
            }
            return setProgress(progress + adjustedStep)
        }, 250);
        if (progress >= 160) clearInterval(interval);

        return () => clearInterval(interval);
    }, [setFile, progress, props])

    function updateFileHandler(index, mode) {
        setProgress(0);
        props.dispatch(updateFile(index, mode))
    }

    function removedConvertTo(index) {
        if (!window.confirm(t('homepage.uploadTable.confirm.removeConvert'))) return;
        props.dispatch(updateFile(index, "removed"))
    }

    function deleteFileHandler(id) {
        props.dispatch(removeFile(id))
    }

    const CustomMenu = forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={className}
                    aria-labelledby={labeledBy}
                >
                    <div className="input-container">
                        <FormControl
                            autoFocus
                            placeholder={t('homepage.uploadTable.selectPlaceholder')}
                            onChange={(event) => { setSearch(event.target.value) }}
                            value={search}
                        />
                        <div className="input-icon-container">
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="list-unstyled options-container">
                        {children}
                    </div>
                </div>
            );
        },
    );

    const renderSelect = () => {
        if (width >= 768) {
            const popperConfig = {
                strategy: "fixed"
            };

            const list = getOutputExtensions(file.type, file.name).desktop
            const optionsArray = []

            Object.keys(list).forEach(element => {
                const filteredList = []
                list[element].forEach(item => {
                    if (!search || item.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                        filteredList.push(item)
                    }
                })

                if (filteredList.length > 0) {
                    optionsArray.push(
                        <Dropdown.Item key={element} disabled>
                            <span className="dropdown-item-text">{t(`homepage.uploadTable.selectCategory.${element.toLowerCase()}`)}</span>
                        </Dropdown.Item>
                    )
                    filteredList.forEach(item => {
                        optionsArray.push((
                            <Dropdown.Item key={item} onClick={() => { updateFileHandler(props.updateIndex, item) }}>
                                <div className="dropdown-item-icon" dangerouslySetInnerHTML={{ __html: getIcon(item) }} />
                                <span className="dropdown-item-text">{item.toUpperCase()}</span>
                                <span className="dropdown-item-description">{t(`homepage.uploadTable.selectItem.${item.toLowerCase()}`)}</span>
                            </Dropdown.Item>
                        ))
                    })
                }
            })
            return (
                <Dropdown className={props.error && !file.convertTo ? "dropdown-error" : ""}>
                    <Dropdown.Toggle id="dropdown-convert">
                        {t('homepage.uploadTable.select')}
                        <div className="dropdown-convert-icon"><UploadDropdown /></div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu as={CustomMenu} popperConfig={popperConfig}>
                        {optionsArray.length === 0 ?
                            (<Dropdown.Item key="noOptions" className="no-hover" disabled>
                                <span className="dropdown-item-text">{t('homepage.uploadTable.selectNoOptions')}</span>
                            </Dropdown.Item>)
                            : optionsArray}
                    </Dropdown.Menu>
                </Dropdown>
            );
        } else {
            const list = getOutputExtensions(file.type, file.name).desktop
            const optionsArray = []

            Object.keys(list).forEach(element => {
                const filteredList = []
                list[element].forEach(item => {
                    if (!search || item.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
                        filteredList.push(item)
                    }
                })

                if (filteredList.length > 0) {
                    optionsArray.push(
                        <div className="dropdown-item-mobile dropdown-category" key={element} disabled>
                            <span className="dropdown-item-text">{t(`homepage.uploadTable.selectCategory.${element.toLowerCase()}`)}</span>
                        </div>
                    )
                    filteredList.forEach(item => {
                        optionsArray.push((
                            <button className="dropdown-item-mobile" key={item} onClick={() => { updateFileHandler(props.updateIndex, item) }}>
                                <div className="dropdown-item-icon" dangerouslySetInnerHTML={{ __html: getIcon(item) }} />
                                <span className="dropdown-item-text">{item.toUpperCase()}</span>
                                <span className="dropdown-item-description">{t(`homepage.uploadTable.selectItem.${item.toLowerCase()}`)}</span>
                            </button>
                        ))
                    })
                }
            })
            return (
                <>
                    <button className={props.error && !file.convertTo ? "uploadTable-select dropdown-error" : "uploadTable-select"} onClick={() => { setMobileSelect(true) }}>
                        {t('homepage.uploadTable.selectMobile')}
                    </button>
                    <Modal id="mobile-selecter-modal" show={mobileSelect} onHide={() => { setMobileSelect(false); }}>
                        <Modal.Header closeButton>
                            <p>{t('homepage.uploadTable.selectMobile')}</p>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="input-container">
                                <FormControl
                                    autoFocus
                                    placeholder={t('homepage.uploadTable.selectPlaceholder')}
                                    onChange={(event) => { setSearch(event.target.value) }}
                                    value={search}
                                />
                                <div className="input-icon-container">
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            {optionsArray.length === 0 ?
                                (<div key="noOptions" className="no-hover" disabled>
                                    <span className="dropdown-item-text">{t('homepage.uploadTable.selectNoOptions')}</span>
                                </div>)
                                : optionsArray}
                        </Modal.Body>
                    </Modal>
                </>
            );
        }
    }

    function renderConvertMode() {

        let content = (
            <div className="progress position-relative">
                <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                <small className="justify-content-center d-flex position-absolute w-100">{t(`homepage.uploadTable.progress${props.compress ? "Compress" : ""}`)}</small>
            </div>
        );

        if (props.compress) {
            if (progress >= 100) {
                content = (
                    <div className="dropdown-selected">
                        <p className="dropdown-selected-text no-padding">
                            <span>{`${t(`homepage.uploadTable.compress.gain`)} -${file.bsGain}%`}</span>
                        </p>
                        <div className="dropdown-convert-icon smaller-icon"><UploadValidation /></div>
                    </div>
                )
            }
        } else if (props.split) {
            if (progress >= 160) {
                content = (
                    <div className="dropdown-selected">
                        <span className="dropdown-selected-text no-padding">{t(`homepage.uploadTable.split.result`).replace('<page>', file.pages)}</span>
                        <div className="dropdown-convert-icon smaller-icon"><UploadValidation /></div>
                    </div>
                )
            } else if (progress >= 100) {
                content = (
                    <>
                        <Modal id="loader-modal" show={true} onHide={() => { return; }}>
                            <Modal.Body>
                                <div className="icon-container validation-icon">
                                    <UploadValidation />
                                </div>
                                <h2 className="loading-modal-title">{t('homepage.uploadTable.loadingModalSplit.titleFinished').replace('<page>', file.pages)}</h2>
                                <div className="progress position-relative fade-out-disappear">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                                    <small className="progress-text justify-content-center d-flex position-absolute w-100">{t(`homepage.uploadTable.progressSplit`)}</small>
                                </div>
                                <p className="loading-modal-text fade-out-disappear">{t('homepage.uploadTable.loadingModalSplit.text')}</p>
                            </Modal.Body>
                        </Modal>
                    </>
                )
            } else {
                content = (
                    <>
                        <Modal id="loader-modal" show={true} onHide={() => { return; }}>
                            <Modal.Body>
                                <div className="icon-container">
                                    <img className="img img-fluid loading-icon" src={LoadingIconV2} alt={LoadingIconV2} />
                                    <div className="loading-arrow-icon-container">
                                        <img className="img img-fluid loading-arrow-icon" src={LoadingArrowIcon} alt={LoadingArrowIcon} />
                                    </div>
                                </div>
                                <h2 className="loading-modal-title">{t('homepage.uploadTable.loadingModalSplit.title')}</h2>
                                <div className="progress position-relative">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" />
                                    <small className="progress-text justify-content-center d-flex position-absolute w-100">{t(`homepage.uploadTable.progressSplit`)}</small>
                                </div>
                                <p className="loading-modal-text">{t('homepage.uploadTable.loadingModalSplit.text')}</p>
                            </Modal.Body>
                        </Modal>
                    </>
                )
            }
        } else {
            if (!file.convertTo) {
                content = renderSelect();
            } else {
                content = (
                    <div className="dropdown-selected" onClick={() => { removedConvertTo(props.updateIndex) }}>
                        <div className="dropdown-selected-icon" dangerouslySetInnerHTML={{ __html: getIcon(file.convertTo) }} />
                        <span className="dropdown-selected-text">{file.convertTo.toUpperCase()}</span>
                        <div className="dropdown-convert-icon smaller-icon"><UploadValidation /></div>
                    </div>
                )
            }
        }

        if (file.uploadStatus === UPLOAD_STATUS_ERROR_MAX_SIZE) content = (
            <div className='alert alert-danger' >{t('homepage.uploadTable.error.maxSize', { maxSize: getMaxUploadSize(props.user.user?.metadata?.customerType).label })}</div>
        )

        return content;
    }

    if (!file) return null;

    return (
        (width >= 768) ? (
            <tr className={`uploaded-file-row${props.index % 2 === 1 ? ' green-row' : ''}`} key={props.index}>
            <td className="uploaded-file-data">
                <FontAwesomeIcon icon={faFolder} />
                <OverlayTrigger placement="right"
                    overlay={<Tooltip id={`tooltip-right-${props.index}`}>{file.name}</Tooltip>}
                >
                    <span className="uploaded-file-name">{getDisplayedName(file.name, width)}</span>
                </OverlayTrigger>
            </td>
            <td className="uploaded-file-convert-mode">{renderConvertMode()}</td>
            <td className="text-right">
                <button className="button uploaded-file-delete-button" onClick={() => { deleteFileHandler(props.displayedFile.id) }}>
                    <img className="img img-fluid delete-icon" src={trashIcon} alt={trashIcon} />
                </button>
            </td>
        </tr>
        ) : (
            <div className='uploaded-file-row-mobile' key={props.index}>
                <div className='uploaded-file-data-mobile'>
                    <FontAwesomeIcon icon={faFolder} />
                    <OverlayTrigger placement="right"
                        overlay={<Tooltip id={`tooltip-right-${props.index}`}>{file.name}</Tooltip>}
                    >
                    <span className='uploaded-file-name-mobile'>{getDisplayedName(file.name, width)}</span>
                    </OverlayTrigger>
                    <button className="button uploaded-file-delete-button" onClick={() => { deleteFileHandler(props.displayedFile.id) }}>
                        <img className="img img-fluid delete-icon" src={trashIcon} alt={trashIcon} />
                    </button>
                </div>
                <div className='uploaded-file-convert-mode-mobile'>
                    {renderConvertMode()}
                </div>
            </div>
        )
    )

}

const mapStateToProps = state => ({ file: state.file, user: state.user })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UploadFileTableElement);